export enum ReportType {
    GENERAL_ACH = 'GENERAL_ACH'
}